<template>
    <div class="dashboard_contents">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <tabs>
                        <tab  :name="$store.getters.t('volunteer_backend_notifications_tab_notifications')" :selected="true">
                            <tab-notice type="INFO"/>
                        </tab>
                        <tab  :name="$store.getters.t('volunteer_backend_notifications_tab_requests')">
                            <tab-notice :user="user" type="INTERACTIVE"/>
                        </tab>
                        <tab  :name="$store.getters.t('volunteer_backend_notifications_tab_payments')">
                            <tab-notice type="PAYMENTS"/>
                        </tab>
                    </tabs>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Tabs from './Profile/tabs/Tabs'
import Tab from './Profile/tabs/Tab'
import TabNotice from './Profile/tabs/TabNotice/TabNotice'

export default {
    props:['user'],
    name: "VolunteerBackendNotificationComponent",
    components: {
        Tabs,
        Tab,
        TabNotice,
    },

    data(){
        return{

            time1: null,
            time2: null,
            time3: null,
            activeComponent: null,
                selectCategory:{
                    placeholder: this.$store.getters.t('catalog_filter_categories'),
                    list: [
                        {
                            title: this.$store.getters.t('volunteer_backend_notifications_cat_requests_curator'),
                        },
                        {
                            title: this.$store.getters.t('volunteer_backend_notifications_cat_funds_transfers'),
                        },
                        {
                            title: this.$store.getters.t('volunteer_backend_notifications_cat_comments_followed'),
                        },
                        {
                            title: this.$store.getters.t('volunteer_backend_notifications_cat_replies_requests'),
                        },
                        {
                            title: this.$store.getters.t('volunteer_backend_notifications_cat_welcome'),
                        }

                    ]
                },
                selectStatus:{
                    placeholder: this.$store.getters.t('preview_modal_status'),
                    list: [
                        {
                            title: this.$store.getters.t('tab_pet_status_moderation'),
                        },
                        {
                            title: this.$store.getters.t('tab_pet_status_rejected'),
                        },
                        {
                            title: this.$store.getters.t('tab_pet_status_approved'),
                        }

                    ]
                },
        }
    },

    computed: {
        currentUserData() {
            return this.$store.getters.getUserData;
        },
    },

/*    methods: {

        markAsReadTab( name ){

            this.activeComponent = name

            switch( this.activeComponent ){
                case "Уведомления":
                    this.activeComponent = 'info'
                    break;
                case "Запросы":
                    this.activeComponent = 'interactive'
                    break;
                case "Выплаты":
                    this.activeComponent = 'payments'
                    break;
            }

            if( this.activeComponent === 'info' || this.activeComponent === 'payments' ){
                this.$refs[this.activeComponent].markAsRead( this.activeComponent )
            }

        }

    },*/


}
</script>

<style lang="scss">

.dashboard_contents .tabs__navigation-item + .tabs__navigation-item {
    border-left: none;
}

</style>
